const state = {
  name: 'User',
  token: null,
  refresh: null,
  objUsuario: {}
};

export default state;